import React, { FC } from "react";
import {useMediaQuery} from '@mui/material'
import { MenuItemLink, MenuProps, DashboardMenuItem, useDataProvider, useResourceDefinitions, useSidebarState, useLogout } from 'react-admin';
import { List, PowerSettingsNew } from "@mui/icons-material";
import {useKeycloak} from "@react-keycloak/web";
import {Box} from "@mui/material";

export const Menu = (props: MenuProps) => {
    const { keycloak, initialized } = useKeycloak()

    // @ts-ignore
    // FIXME: isXSmall is always false
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const [open] = useSidebarState();

    const resourcesDefinitions = useResourceDefinitions();
    const resources = Object.keys(resourcesDefinitions).map(name => resourcesDefinitions[name]);

    const logout = useLogout();

    const logoutButton = <MenuItemLink to={''} primaryText={"Logout"} onClick={() => logout()} leftIcon={ <PowerSettingsNew/> }/>

    return (
        <Box>
            <DashboardMenuItem sidebarIsOpen={open}/>
            {resources.map(resource => (
                resource.options && (
                    !resource.options.role || keycloak.realmAccess?.roles.includes(resource.options.role)
                ) &&
                <MenuItemLink
                    key={resource.name}
                    to={`/${resource.name}`}
                    primaryText={
                        (resource.options && resource.options.label) ||
                        resource.name
                    }
                    leftIcon={
                        resource.icon ? <resource.icon /> : <List />
                    }
                    sidebarIsOpen={open}
                />
            ))}
            { isXSmall && logoutButton }
        </Box>
    );
};

export default Menu;
